import { Injectable, signal } from '@angular/core';

export enum CommonInfoModalKey {
	CHAT_AI_HOW_IT_WORKS = 'CHAT_HOW_IT_WORKS',
}

@Injectable({ providedIn: 'root' })
export class CommonInfoModalsService {
	public readonly $modalToOpen = signal<CommonInfoModalKey | null>(null, { equal: () => false });

	public openModalBykey(key: CommonInfoModalKey): void {
		this.$modalToOpen.set(key);
	}
}
